import { useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/trpc/react.ts'

/** 页面回调负责列表与财务刷新；这里补齐归属修改影响的跨模块选择器。 */
export function useOrderBatchUpdateRefresh(onSaved: () => Promise<void>) {
  const cache = useQueryClient()
  const trpc = useTRPC()
  return async () => {
    await Promise.all([
      cache.invalidateQueries(trpc.order.groups.options.queryFilter()),
      cache.invalidateQueries(trpc.order.subjects.list.queryFilter()),
      cache.invalidateQueries(trpc.order.subjects.options.queryFilter()),
      onSaved()
    ])
  }
}
